<div>
  <div *ngIf="showContainerUser" class="container-user">
    <div class="flex flex-row justify-content-between align-items-center align-content-center horizontal-separator">
      <div class="flex flex-row">
        <div class="flex pr-2">
          <div class="icon-link">
            <span *ngIf="materialIconsReady" class="material-symbols-outlined icon-user">
              person
            </span>
          </div>
        </div>

        <div class="flex flex-column">
          <span class="my-0 text-user-profile text-color-profile">
            <app-text-preview-tooltip
              [text]="userCompleteName"
              [maxWidth]="250">
            </app-text-preview-tooltip>
          </span>
          <div class="flex flex-wrap">
            <span class="span-text text-profile text-color-profile white-space-normal">{{profileName}}</span>
            <span *ngIf="profileCompanyName" class="text-separator my-1"></span>
            <p class="span-text text-profile text-color-profile break-word my-0 py-0">
              {{profileCompanyName}}
            </p>
          </div>
        </div>
      </div>

      <div class="flex">
        <div (click)="redirectToUserContactInfo()"
          class="icon-config-btn justify-content-end" onkeypress="">
          <i class="pi pi-cog icon-config-text"></i>
        </div>
      </div>
    </div>
  </div>

  <p-panelMenu [model]="items">
    <ng-template let-item pTemplate="item">
    </ng-template>
  </p-panelMenu>
</div> 